import React, { Component } from 'react';
import * as THREE from "three";
import './app.css';
import adrift from './adrift.mp3';
//import satie from './satie.mp4';
import audio from './audio';

const camLeftBounds = -40;
const camRightBounds = 100;
const camTopBounds = 40;
const camBottomBounds = -50;
const camSpeed = .05;

export default class App extends Component {

    constructor() {
        super();
        this.containerRef = React.createRef();
        this.audioRef = React.createRef();
        this.init();
    }

    state = {
        isPlaying: false,
        hasPlayed: false
    }

    init() {
        const { innerHeight, innerWidth } = window;

        this.cameraDirectionX = 'right';
        this.cameraDirectionY = 'forward';

        // Setup scene & camera
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(60, innerWidth/innerHeight, 1, 1000);
        this.camera.position.z = 15;

        this.camera.rotation.x = 1.16;
        this.camera.rotation.y = -0.12;

        // Setup renderer & color
        this.renderer = new THREE.WebGLRenderer();
        this.scene.fog = new THREE.FogExp2('#cf3476', 0.002);
        this.renderer.setClearColor(this.scene.fog.color);
        this.renderer.setSize(innerWidth, innerHeight);

        // Setup lighting
        const ambient = new THREE.AmbientLight(0x555555);
        const directional = new THREE.DirectionalLight(0xffeedd);
        directional.position.set(0,0,1);

        const genericLight = new THREE.PointLight(0xffffff, 1, 150);
        genericLight.position.set(10, 0, 25);

        // Setup lightning effect
        this.flash = new THREE.PointLight(0x062d89, 30, 500 ,1.7);
        this.flash.position.set(200,300,100);

        this.scene.add(ambient);
        this.scene.add(directional);
        this.scene.add(genericLight);
        this.scene.add(this.flash);

        this.cloudParticles = [];

        // Make responsive
        window.addEventListener('resize', () => {
            const { innerHeight, innerWidth } = window;
            this.renderer.setSize(innerWidth, innerHeight);
            this.camera.aspect = innerWidth / innerHeight;
            this.camera.updateProjectionMatrix();
        });
    }

    setupBkgObjects() {
        let loader = new THREE.TextureLoader();

        // Setup clouds
        loader.load('./smoke.png', (texture) => {
            const cloudGeo = new THREE.PlaneBufferGeometry(500,500);

            const cloudMaterial = new THREE.MeshLambertMaterial({
                map: texture,
                transparent: true
            });

            for (let p=0; p<25; p++) {
                let cloud = new THREE.Mesh(cloudGeo, cloudMaterial);

                cloud.position.set(
                    Math.random()* 800 -400,
                    500,
                    Math.random()* 500 - 450
                );

                cloud.rotation.x = 1.16;
                cloud.rotation.y = -0.12;
                cloud.rotation.z = Math.random() * 360;
                cloud.material.opacity = 0.6;
                this.cloudParticles.push(cloud);
                this.scene.add(cloud);
            }
        });

        // Setup stars
        this.starGeo = new THREE.Geometry();

        for (let i=0; i < 15000; i++) {
            let starDrop = new THREE.Vector3(
                Math.random() * 400 - 200,
                Math.random() * 500 - 250,
                Math.random() * 400 - 200
            );
            starDrop.velocity = 0;
            this.starGeo.vertices.push(starDrop);
        }

        let starMaterial = new THREE.PointsMaterial({
            color: 0xffffff,
            size: 0.1,
            transparent: true
        });

        this.star = new THREE.Points(this.starGeo, starMaterial);

        this.scene.add(this.star);
    }

    setupShapes() {
        const bufferLength = this.audio.frequencyArray.length;
        let sphX = -77;
        this.spheres = [];

        const customMaterial = new THREE.ShaderMaterial(
            {
                uniforms:
                {
                    'c':   { type: 'f', value: .5 },
                    'p':   { type: 'f', value: .5 },
                    glowColor: { type: 'c', value: new THREE.Color(0x0000ff) },
                    viewVector: { type: 'v3', value: this.camera.position }
                },
                vertexShader:   document.getElementById( 'vertexShader'   ).textContent,
                fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
                side: THREE.FrontSide,
                blending: THREE.AdditiveBlending,
                transparent: true
            }
        );

        for (let i = 0; i <  bufferLength; i++) {
            const geo = new THREE.SphereGeometry(1, 10, 10);
            const material = new THREE.MeshLambertMaterial({
                color: '#' + Math.floor(Math.random()*16777215).toString(16),
                emissive: 'yellow',
                emissiveIntensity: 0.3
            });

            const sphere = new THREE.Mesh(geo, material);

            sphere.position.set(sphX, 60, -20);
            this.scene.add(sphere);


            const glow = new THREE.Mesh(geo.clone(), customMaterial.clone());

            glow.position.set(sphere.position.x, sphere.position.y, sphere.position.z)
            glow.scale.multiplyScalar(1.2);

            this.scene.add(glow);
            this.spheres.push([sphere, glow]);

            sphX += 4;
        }


    }

    moveCamera() {
        if (this.camera.position.x <= camRightBounds && this.cameraDirectionX === 'right') {
            this.camera.position.x += camSpeed;
        } else if (this.camera.position.x >= camRightBounds && this.cameraDirectionX === 'right') {
            this.cameraDirectionX = 'left';
        } else if (this.camera.position.x >= camLeftBounds && this.cameraDirectionX === 'left') {
            this.camera.position.x -= camSpeed;
        } else if (this.camera.position.x <= camLeftBounds && this.cameraDirectionX === 'left') {
            this.cameraDirectionX = 'right';
        }

        if (this.camera.position.y <= camTopBounds && this.cameraDirectionY === 'forward') {
            this.camera.position.y += camSpeed;
        } else if (this.camera.position.y >= camTopBounds && this.cameraDirectionY === 'forward') {
            this.cameraDirectionY = 'backward';
        } else if (this.camera.position.y >= camBottomBounds && this.cameraDirectionY === 'backward') {
            this.camera.position.y -= camSpeed;
        } else if (this.camera.position.y <= camBottomBounds && this.cameraDirectionY === 'backward') {
            this.cameraDirectionY = 'forward';
        }
    }

    animate() {
        const { frequencyAnalyser, frequencyArray } = this.audio;

        this.moveCamera();

        // Animate cloud effect
        this.cloudParticles.forEach(p => {
            p.rotation.z -= 0.002;
        });

        // Animate lightning effect
        if (Math.random() > 0.93 || this.flash.power > 100) {
            if (this.flash.power < 100) {
                this.flash.position.set(
                    Math.random() * 400,
                    300 + Math.random() * 200,
                    100
                );
            }
            this.flash.power = 50 + Math.random() * 500;
        }

        // Set audio arrays data
        frequencyAnalyser.getByteFrequencyData(frequencyArray);

        this.spheres.forEach((s, i) => {
            const sphere = s[0];
            const glow = s[1];

            sphere.rotation.x += 0.05;
            sphere.rotation.y += 0.05;

            let height = frequencyArray[i];

            if (height < 60) {
                height = 60;
            }

            sphere.position.y = height;
            glow.position.y = height;
        });

        this.renderer.render(this.scene, this.camera);
        this.animationReq = requestAnimationFrame(this.animate.bind(this));
    }

    componentDidMount() {
        this.containerRef.current.appendChild(this.renderer.domElement);
    }

    play = () => {
        this.setState({
            isPlaying: true
        });

        if (!this.state.hasPlayed) {
            this.audio =  audio(this.audioRef.current);
            this.setupBkgObjects();
            this.setupShapes();
        }

        this.animate();
        this.audioRef.current.play();
    }

    onEnded = () => {
        setTimeout(() => {
            this.setState({
                isPlaying: false,
                hasPlayed: true
            });

            cancelAnimationFrame(this.animationReq);
            this.camera.position.set(0, 0, 15);
        }, 7000);
    }

    render() {
        const { isPlaying } = this.state;
        let className = 'play';

        className = isPlaying ? className + ' hide' : className;

        return (
            <div className="app-container" ref={this.containerRef}>
                <audio ref={this.audioRef} onEnded={this.onEnded}>
                    <source src={adrift} type="audio/mpeg"/>
                </audio>
                <div className={className}>
                    <button onClick={this.play}><span>Pla</span>y</button>
                    <div className="headphones">
                        <div className="head"></div>
                        <div className="ear"></div>
                    </div>
                    <p>Music: "Adrift" by Be Still The Earth</p>
                </div>
            </div>
        );
    }
}
